import { Box } from "@chakra-ui/react";
import { Col } from "antd";
import { ContaForm } from "core/features/conta/typings";
import { OperacaoEnum } from "core/resources/enums/conta";
import { Control } from "react-hook-form";
import InputFile from "components/Input/InputFile";
import FieldTipoDocumento from "./FieldTipoDocumento";
import { InputBaseWrapper } from "./InputBaseWrapper";
import InputToggleContent from "components/Input/InputToggleContent/index";
import Field from "components/Input/Field";

interface DocumentoFiscalProps {
  control: Control<ContaForm, object>;
  operacao: OperacaoEnum;
}

function DocumentoFiscal({ control, operacao }: DocumentoFiscalProps) {
  return (
    <Box mb={2}>
      <Field
        shouldUnregister
        control={control}
        name="documentoFiscal"
        render={({ field: toggle }) => (
          <InputToggleContent
            label="Documento fiscal"
            active={!!toggle.value}
            onToggle={toggle.onChange}
            size="sm"
          >
            <InputBaseWrapper gutter={16}>
              <Box as={Col} xs={8}>
                <Field
                  shouldUnregister
                  control={control}
                  name="dataDocumento"
                  label="Data da emissão"
                  rules={{
                    max: "2100-01-01",
                  }}
                  inputProps={{
                    type: "date",
                    max: "2100-01-01",
                  }}
                />
              </Box>

              <Box as={Col} xs={8}>
                <Field
                  shouldUnregister
                  control={control}
                  name="numeroDocumento"
                  label="Número da nota"
                />
              </Box>

              <Box as={Col} xs={8}>
                <Field
                  shouldUnregister
                  control={control}
                  name="serieNota"
                  label="Série da nota"
                />
              </Box>
            </InputBaseWrapper>

            {operacao === OperacaoEnum.Despesa ? (
              <InputBaseWrapper gutter={32}>
                <Box as={Col} xs={12}>
                  <FieldTipoDocumento control={control} />
                </Box>

                <Box as={Col} xs={12}>
                  <Field
                    shouldUnregister
                    control={control}
                    name="xml"
                    render={({ field }) => (
                      <Box pt={5}>
                        <InputFile
                          value={field.value}
                          onChange={field.onChange}
                          label="Arquivo XML"
                          accept="text/xml"
                        />
                      </Box>
                    )}
                  />
                </Box>
              </InputBaseWrapper>
            ) : null}
          </InputToggleContent>
        )}
      />
    </Box>
  );
}

export default DocumentoFiscal;
